<template>
  <v-dialog v-model="localDialog" scrollable lazy width="800px">
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.global.cookiesPolicy').toUpperCase() }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-container>
          <v-layout row wrap>
            <v-flex v-html="$t('terms.cookies.content')" />
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="$emit('update:dialog', false)" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogCookies',
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    localDialog: {
      get() {
        return this.dialog
      },
      set() {
        this.$emit('update:dialog', false)
      },
    },
  },
}
</script>
